import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const PrivateRoute = () => {
  const { currentUser } = useContext(AuthContext);
  const location = useLocation();

  if (!currentUser) {
    return <Navigate to="/login" />;;
  }

  const isIncomplete = !currentUser.firstName || !currentUser.lastName || !currentUser.phone;
  if (isIncomplete && location.pathname !== '/account') {
    return <Navigate to="/account" replace state={{ incompleteProfile: true }} />;;
  }

  return <Outlet />;;
};

export default PrivateRoute;